import Vue from "vue";
import VueRouter from "vue-router";
import axios from "axios";
import {
    Message
} from 'element-ui';
Vue.use(VueRouter);


const routes = [{
    path: "/login",
    name: "login",
    component: () =>
        import ("../views/Login.vue"),
    meta: {
        title: "登录"
    }
}, {
    path: "/register",
    name: "register",
    component: () =>
        import ("../views/Register.vue"),
    meta: {
        title: "注册"
    }
}, {
    path: "/index",
    name: "index",
    component: () =>
        import ("../views/read/Index.vue"),
    meta: {
        title: "调阅首页"
    }
}, {
    path: "/detail",
    name: "detail",
    component: () =>
        import ("../views/read/Detail.vue"),
    meta: {
        title: "患者详情"
    }
}, {
    path: "/list",
    name: "list",
    component: () =>
        import ("../views/List.vue"),
    meta: {
        title: "患者相关检查"
    }
}, {
    path: "/images",
    name: "images",
    component: () =>
        import ("../views/Images.vue"),
    meta: {
        title: "未匹配图像列表"
    }
}, {
    path: "/iframe",
    name: "iframe",
    component: () =>
        import ("../views/Iframe.vue"),
    meta: {
        title: "影像调阅"
    }
}, {
    path: "/report/login",
    name: "login2",
    component: () =>
        import ("../views/write/Login.vue"),
    meta: {
        title: "书写报告登录"
    }
}, {
    path: "/report/index",
    name: "index2",
    component: () =>
        import ("../views/write/Index.vue"),
    meta: {
        title: "患者报告首页"
    }
}, {
    path: "/report/detail",
    name: "detail2",
    component: () =>
        import ("../views/write/Detail.vue"),
    meta: {
        title: "患者书写报告"
    }
}]

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes
});

router.beforeEach(async(to, from, next) => {
    next();
    //单点登录
    if (to.path === "/index" || to.path === "/report/index") {
        if (to.query.token) {
            let _aestoken = to.query.token;
            let _tokenObj = JSON.parse(aes.AESDecrypt(decodeURIComponent(_aestoken)));
            if (_tokenObj.access_token) {
                localStorage.setItem(
                    "mobile_internet_writing_token",
                    _aestoken
                );
                localStorage.setItem(
                    "mobile_internet_writing_accessToken",
                    _tokenObj.token_type + " " + _tokenObj.access_token
                );
                localStorage.setItem(
                    "mobile_internet_writing_expires_1",
                    _tokenObj.expires
                );
                localStorage.setItem(
                    "mobile_internet_writing_expires",
                    _tokenObj.expires_in
                );
                localStorage.setItem(
                    "mobile_internet_writing_newsExpires",
                    _tokenObj.expires_in
                );
                localStorage.setItem(
                    "mobile_internet_writing_refresh_token",
                    _tokenObj.refresh_token
                );
            }
        }
        if (to.query.currentHospitalCode) {
            let _currentHospitalCode = JSON.parse(
                aes.AESDecrypt(
                    decodeURIComponent(to.query.currentHospitalCode)
                )
            );
            localStorage.setItem(
                "hospitalCode",
                _currentHospitalCode.hospitalCode
            );
            //获取所有医院
            axios({
                url: window.g.API_ROOT + "/api/v1/hospital/getlist",
                method: "get",
                params: {}
            }).then(res => {
                if (res.data.Code == 10000) {
                    localStorage.setItem(
                        "allHospital",
                        JSON.stringify(res.data.Content.List)
                    );
                } else {
                    Message.warning(res.data.Message);
                }
            });
            localStorage.setItem("navTitle", _currentHospitalCode.hospitalName);
        }
    }
});

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js